import React, { Component } from 'react';
import { Navbar, Nav} from 'react-bootstrap';
import {ShoppingCartOutlined} from '@material-ui/icons'
import {IconButton, Badge, Button} from '@material-ui/core';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {connect} from 'react-redux';
import '../stylesheets/Navbar.css';

import SignIn from './Authentication/SignIn'

/* <IconButton key="close" color="inherit" onClick={this.props.handleErrorClose}><ShoppingCartOutlined style={{fontSize: 20}} /></IconButton> */

const theme = createMuiTheme({
  palette: {
    primary: { 
      main: '#45b97c',
      contrastText: "white"
    }
  }
})

class NavbarCommon extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      email: '',
      password: ''
    }
  }

  openAndCloseAuth = () => {
    this.setState({
      open: !this.state.open
    })
  }

  handleChange = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  render() {
    const ShoppingIcon = () => (
      <MuiThemeProvider theme={theme}>
        <IconButton aria-label="Cart">
          <Badge badgeContent={this.props.Cart.items ? this.props.Cart.items.length : 0} color="primary">
            <ShoppingCartIcon />
          </Badge>
        </IconButton>
      </MuiThemeProvider>

    )
    return (
    <div>
      <SignIn open={this.state.open} handleClose={this.openAndCloseAuth} />
      <div className="header-nav">
        <Navbar style={navStyle} variant="light" expand="lg" >
          <Navbar.Brand>
          <a href="/">
            <img className="navLogo" src={process.env.PUBLIC_URL + '/images/Livelo-Logo.png'} alt='Logo' style={{width:150, marginTop: -7}}/>
          </a>
          </Navbar.Brand>



          <Nav className="navbar-right cartNav">
            {/* <Nav.Link className="navbar-right" href="/cart"><ShoppingCartOutlined style={{fontSize: 26, color: 'black'}} /></Nav.Link> */}
            <Nav.Link className="navbar-right cartNav" href="/cart"><ShoppingIcon /></Nav.Link>
          </Nav>
          <Nav className="navbar-right authNav">
            <Nav.Link className="navbar-right authNav"><Button size="medium" onClick={this.openAndCloseAuth} color="inherit" variant="outlined" style={{color: 'black'}}>Login / Signup</Button></Nav.Link>
          </Nav>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
  
          <Navbar.Collapse id="basic-navbar-nav" style={{justifySelf: 'flex-end'}}>
            <Nav className="mr-auto">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link className="authNavCollapse"><Button size="medium" onClick={this.openAndCloseAuth} color="inherit" variant="outlined" style={{color: 'black'}}>Login / Signup</Button></Nav.Link>
            </Nav>
          </Navbar.Collapse>



        </Navbar>
      </div>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth,
    Cart: state.Cart
  }
}

const navStyle = {
  backgroundColor: 'white',
  minHeight: 80
}

export default connect(mapStateToProps)(NavbarCommon);